export const getInitials = (name: string) => {
  const words = name.split(' ')
  return `${words[0][0]}${words.length > 1 ? words[words.length - 1][0] : ''}`
}

export const getInitialsFrom = (firstName: string, lastName?: string) => {
  return `${firstName[0]}${lastName ? lastName[0] : ''}`
}

export const pluralize = (count: number) => {
  const pluralRules = new Intl.PluralRules('en')
  const pluralForm = pluralRules.select(count)
  return pluralForm === 'one' ? '' : 's'
}

export const capitalizeOfWords = (word?: string) => {
  if (word) return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  else return ''
}

export const getDateFromDateTime = (datetime?: string) => {
  if (datetime)
    return datetime.includes('T') ? datetime.split('T')[0] : datetime
  else return ''
}

//Update this list when Organisations wantes to add another proper noun
const properNouns = ['Haitian Creole', 'Medicare Advantage']
export const capitalizeListOfWords = (words?: string | string[]) => {
  if (words) {
    const wordList = (Array.isArray(words) ? words : [words]).filter(
      (w): w is string => typeof w === 'string'
    )
    return wordList.map((word) => {
      // Normalize the word to lowercase for comparison
      const normalizedWord = word.trim().toLowerCase()
      // Check if the word matches any proper noun (case-insensitive)
      if (
        properNouns.find(
          (properNoun) => properNoun.toLowerCase() === normalizedWord
        )
      ) {
        return (
          properNouns.find(
            (properNoun) => properNoun.toLowerCase() === normalizedWord
          ) || word
        )
      }

      // Split the word into two parts
      const wordParts = word.split(' ')

      // If it's two words, handle capitalization for both words
      if (wordParts.length === 2) {
        return (
          wordParts[0].charAt(0).toUpperCase() +
          wordParts[0].slice(1).toLowerCase() +
          ' ' +
          wordParts[1].charAt(0).toLowerCase() +
          wordParts[1].slice(1).toLowerCase()
        )
      }

      // Handle single-word case
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
  }

  return []
}
